import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useUserSettings } from "@sukha/query";
import { resolveSmartAssistantSettings } from "@sukha/shared/domain/smartAssistantSettings";

/**
 * The member's settings with each NULL SmartAssistant column resolved to what
 * they actually get (TX-5174). The settings page and assistant playback both
 * read through this, so they cannot disagree.
 *
 * `effectiveSettings` is undefined until settings load.
 */
export function useEffectiveUserSettings() {
  const $ = _c(6);
  const {
    data: userSettings,
    isLoading: userSettingsLoading
  } = useUserSettings();
  let t0;
  if ($[0] !== userSettings) {
    t0 = userSettings ? resolveSmartAssistantSettings(userSettings) : undefined;
    $[0] = userSettings;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const effectiveSettings = t0;
  let t1;
  if ($[2] !== effectiveSettings || $[3] !== userSettings || $[4] !== userSettingsLoading) {
    t1 = {
      userSettings,
      userSettingsLoading,
      effectiveSettings
    };
    $[2] = effectiveSettings;
    $[3] = userSettings;
    $[4] = userSettingsLoading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}